/* eslint-disable */
import { scan } from "react-scan";
import { MsalProvider } from "@azure/msal-react";
import { initializeMsal } from "./service/microsoftService/MicrosoftUtil";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import "asset/custom.css";
import { ACL_SESSION_STORAGE, IS_ACL_ENABLED, IS_ROUTE_ENABLED } from "component/utils/Constant";
import { getEnvVariableValue } from "util/CommonUtil";
import { ENV_VAR } from "util/Constant";
import "./i18n";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoginConfig from "model/LoginConfig.model";
import LoginAPIService from "service/LoginAPIService";
import * as Sentry from "@sentry/react";

// Initialize React Scan
// scan({
//   enabled: true,
// });

const isTenantBasedLoginConfig = getEnvVariableValue("VITE_LOAD_TENANT_BASED_LOGIN_CONFIG");
let loginConfig: LoginConfig = JSON.parse(getEnvVariableValue("VITE_LOGIN_CONFIG") ?? "null");

//Get the subdomain, if it is not localhost otherwise set "development"
const subdomain = window.location.hostname.split(".")[0];
let FEenvironment = subdomain === "localhost" ? "development" : subdomain;
const backendUrl = getEnvVariableValue(ENV_VAR.VITE_BASE_API_URL);
const backendSubdomain = new URL(backendUrl).hostname?.split(".")[0];

const BEenvironment = backendSubdomain === "localhost" ? "development" : backendSubdomain;

// Sentry initialization
if (getEnvVariableValue("VITE_ENABLE_SENTRY")) {
  Sentry.init({
    dsn: "https://19a3cd22ed63c80ee561ea67693b4863@o4508852942340096.ingest.us.sentry.io/4508964264214528",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserSessionIntegration(),
      Sentry.replayIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.browserApiErrorsIntegration({
        setTimeout: true,
        setInterval: true,
        requestAnimationFrame: true,
        XMLHttpRequest: true,
        eventTarget: true,
      }),
    ],
    environment: `${FEenvironment}-${BEenvironment}`,
    release: __APP_VERSION__,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    //Localhost, anything ends with neubird.ai and anything ends with web-devapp.com
    tracePropagationTargets: [/localhost/, /neubird\.ai$/, /web-devapp\.com$/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

(async () => {
  if (isTenantBasedLoginConfig) {
    loginConfig = (await LoginAPIService.getTenantConfigData()) as LoginConfig;
  }

  let msalInstance: any = null;
  if (loginConfig?.ENABLE_MICROSOFT_LOGIN) {
    // Initialize MSAL
    msalInstance = initializeMsal(loginConfig);
  }

  //Get google client ID
  let googleAuthClientID: string = "";
  if (loginConfig?.ENABLE_GOOGLE_LOGIN) {
    googleAuthClientID = loginConfig.SSO_PROVIDER[1].CLIENT_ID;
  }

  // to hide console in prod
  if (getEnvVariableValue(ENV_VAR.VITE_SHOW_LOGS) === "false")
    console.log = () => {
      return;
    };

  // configure withAuth Hoc
  if (getEnvVariableValue(ENV_VAR.VITE_IS_ACL_ENABLED) === IS_ACL_ENABLED.Y) {
    sessionStorage.setItem(ACL_SESSION_STORAGE.IS_ACL_ENABLED, IS_ACL_ENABLED.Y);
  }

  if (getEnvVariableValue(ENV_VAR.VITE_IS_ROUTE_GUARD) === IS_ROUTE_ENABLED.Y) {
    sessionStorage.setItem(ACL_SESSION_STORAGE.IS_ROUTE_GUARD, IS_ROUTE_ENABLED.Y);
  }
  const container = document.getElementById("root");
  const root = createRoot(container!);

  switch (true) {
    case loginConfig?.ENABLE_MICROSOFT_LOGIN && !loginConfig?.ENABLE_GOOGLE_LOGIN:
      root.render(
        <>
          <div id="errorDiv12399" className="" />
          <div id="notificationBanner8328" className="sticky z-50" style={{ top: "0px" }} />
          <div id="transparent-mask" />
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
          <div
            id="notificationBannerBottom98328"
            className="sticky z-40"
            style={{ bottom: "0px" }}
          />
        </>
      );
      break;
    case loginConfig?.ENABLE_GOOGLE_LOGIN && !loginConfig?.ENABLE_MICROSOFT_LOGIN:
      root.render(
        <>
          <div id="errorDiv12399" className="" />
          <div id="notificationBanner8328" className="sticky z-50" style={{ top: "0px" }} />
          <div id="transparent-mask" />
          <GoogleOAuthProvider clientId={googleAuthClientID}>
            <App />
          </GoogleOAuthProvider>
          <div
            id="notificationBannerBottom98328"
            className="sticky z-40"
            style={{ bottom: "0px" }}
          />
        </>
      );
      break;
    case loginConfig?.ENABLE_GOOGLE_LOGIN && loginConfig?.ENABLE_MICROSOFT_LOGIN:
      root.render(
        <>
          <div id="errorDiv12399" className="" />
          <div id="notificationBanner8328" className="sticky z-50" style={{ top: "0px" }} />
          <div id="transparent-mask" />
          <MsalProvider instance={msalInstance}>
            <GoogleOAuthProvider clientId={googleAuthClientID}>
              <App />
            </GoogleOAuthProvider>
          </MsalProvider>
          <div
            id="notificationBannerBottom98328"
            className="sticky z-40"
            style={{ bottom: "0px" }}
          />
        </>
      );
      break;
    default:
      root.render(
        <>
          <div id="errorDiv12399" className="" />
          <div id="notificationBanner8328" className="sticky z-50" style={{ top: "0px" }} />
          <div id="transparent-mask" />
          <App />
          <div
            id="notificationBannerBottom98328"
            className="sticky z-40"
            style={{ bottom: "0px" }}
          />
        </>
      );
      break;
  }

  if (getEnvVariableValue("VITE_ENABLE_PWA_MODE")) {
    // to enable PWA mode uncomment the following
    serviceWorker.register({
      onSuccess: () => {
        console.log("SW >>> SUCCESSFULLY REGISTERED!!!");
      },
      onUpdate: (reg: any) => {
        console.log("SW >>> NEW UPDATE IS AVAILABLE!!!");
      },
    });
  } else {
    // standard mode service workers are off i.e not PWA mode
    serviceWorker.unregister();
  }
})();
